import { omitBy, isNil, isEmpty, isUndefined, find } from "lodash";
import statesCities from "Components/profile/profile-details/addresses/country_MY.json";
import { useEffect } from "react";

const model = (data: any) => {
  return omitBy(
    {
      _id: data._id,
      fullName: !isEmpty(data.fullName) ? data.fullName : undefined,
      dob: !isEmpty(data.dob) ? data.dob : undefined,
      primaryEmail: !isEmpty(data.primaryEmail) ? data.primaryEmail : undefined,
      gender: !isEmpty(data.gender) ? data.gender : undefined,
      primaryPhone: data.primaryPhone.number
        ? {
            countryCode: data.primaryPhone.countryCode,
            number: data.primaryPhone.number,
            fullNumber: `${data.primaryPhone.countryCode}${data.primaryPhone.number}`,
          }
        : undefined,
      primaryAddress: data.primaryAddress.street1
        ? omitBy(
            {
              type: data.primaryAddress.type,
              street1: data.primaryAddress.street1,
              street2: data.primaryAddress.street2 ? data.primaryAddress.street2 : undefined,
              city: data.primaryAddress.city,
              cityCode: find(
                find(statesCities.STATES, (element) => data.primaryAddress.state === element.NAME)
                  ?.CITIES,
                (element) => element.NAME === data.primaryAddress.city
              )?.CODE,
              state: data.primaryAddress.state,
              stateCode: find(
                statesCities.STATES,
                (element) => data.primaryAddress.state === element.NAME
              )?.CODE,
              postcode: data.primaryAddress.postcode,
              country: data.primaryAddress.country,
            },
            (value) => isUndefined(value)
          )
        : undefined,
      addresses: !isEmpty(data.addresses)
        ? data.addresses.map((address) => {
            return omitBy(
              {
                type: address.type,
                street1: address.street1,
                street2: address.street2 ? address.street2 : undefined,
                city: address.city,
                cityCode: find(
                  find(statesCities.STATES, (element) => address.state === element.NAME)?.CITIES,
                  (element) => element.NAME === address.city
                )?.CODE,
                state: address.state,
                stateCode: find(statesCities.STATES, (element) => address.state === element.NAME)
                  ?.CODE,
                postcode: address.postcode,
                country: address.country,
              },
              (value) => isUndefined(value)
            );
          })
        : [],
      image: data.image ? data.image : undefined,
      image_file: data.image_file ? data.image_file : undefined,
      logoBase64String: !isEmpty(data.logoBase64String) ? data.logoBase64String : undefined,
      identification: {
        type: !isEmpty(data.identificationType) ? data.identificationType : undefined,
        no: !isEmpty(data.identificationNumber) ? data.identificationNumber : undefined,
        issueDate: !isEmpty(data.identificationIssueDate)
          ? data.identificationIssueDate
          : undefined,
        expiryDate: !isEmpty(data.identificationExpiryDate)
          ? data.identificationExpiryDate
          : undefined,
        placeOfIssue: !isEmpty(data.identificationPlaceOfIssue)
          ? data.identificationPlaceOfIssue
          : undefined,
      },
    },
    (value) => isUndefined(value)
  );

  // const profile: Partial<Profile> = omitBy(
  //     {
  //       _id: data._id,
  //       fullName: data.fullName,
  //       identification: {
  //         no: data.identificationNumber,
  //         type: data.identificationType,
  //         issueDate: data.identificationIssueDate,
  //         expiryDate: data.identificationExpiryDate,
  //         placeOfIssue: data.identificationPlaceOfIssue,
  //       },
  //       primaryEmail: data.email,
  //       primaryPhone: !data.contactNumber
  //         ? undefined
  //         : {
  //             countryCode: data.contactNumber?.dialCode,
  //             number: data.contactNumber?.number,
  //             type: 'MOBILE',
  //             fullNumber: `${data.contactNumber?.dialCode}${data.contactNumber?.number}`,
  //           },
  //       primaryAddress: {
  //         type: 'HOME',
  //         street1: data.addressLine1,
  //         street2: data.addressLine2,
  //         city: data.city,
  //         state: data.state,
  //         postcode: data.postcode,
  //         country: data.country,
  //       },
  //       orgID: data.orgID,
  //       dob: data.dob,
  //       gender: data.gender,
  //     },
  //     (s) => isNil(s) || s === '',
  //   );

  //   return omitBy(
  //     {
  //       profile,
  //     },
  //     (value) => isUndefined(value),
  //   );
};

export default model;
